<template lang="pug">
.reviews-wrap2
  .top10wd-wrapper
    .title-wrapper
      .title {{$tc('ui.withdrawal_topten')}}
      .update {{$tc('ui.daily_update')}}
    .top-list
      .top-list-row(v-for="(player, index) in topWithdrawal")
        .name-wrapper
          .icon
            img(v-if="index ===0" src='assets/img/player_badge/top1.png')
            img(v-else-if="index ===1" src='assets/img/player_badge/top2.png')
            img(v-else-if="index ===2" src='assets/img/player_badge/top3.png')
            img(v-else src='assets/img/player_badge/normal.png')
          .name-wrap
            .name(v-if="player.nickname") {{player.nickname}}
            .name(v-else) {{player.member_id}}
            .text {{$tc('ui.has_withdraw')}}
        .amount PHP {{ $numeral(player.withdrawal_amount).format("0,0.00") }}     
  .charts-wrapper
    #chartsWd
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import Highcharts from 'highcharts';
// import Exporting from 'highcharts/modules/exporting';
// import topTenGames from '@/components2/_topTenPopularGames.vue'
// import bWinnerList from '@/_winnerList'
export default {
  components:{
    // topTenGames,
    // bWinnerList
  },
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      topWithdrawal: [],
      topWinners: [],
      hourlyWithdrawal: {},
      registeredPlayer: 0,
      withdrawSpeed:0,
      activePlayer: 0,
      withdrawalCount: 0,
      reviewCount: 0,
      displayChart: null,
      // bWinnerList: bWinnerList.winner_list
      // triggerFunction: false
    }
  },
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  watch:{
    getLanguage(newState, oldState){
      if(newState){
        this.getGraphData()
      }
    },
  },
  destroyed() {
    // this.triggerFunction = false;
  },
  mounted(){
    this.getGraphData();
    $(".purple-box-slider .slider").slick({
      arrows: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
          {
              breakpoint: 767,
              settings: {
              arrows: false,  
              slidesToShow: 2,
              slidesToScroll: 2,
              }
          },
          {
              breakpoint: 480,
              settings: {
              arrows: false,  
              slidesToShow: 1,
              slidesToScroll: 1,
              }
          },

      ]
    });
    $(".pin").addClass("fast");
    var vm = this
    // $(window).resize(function () {
    //   if ($(window).width() < 1280) {
    //     vm.displayChart.setSize($(window).width() - 20, null);
    //   }else{
    //     vm.displayChart.setSize($('.chart2-wrapper').width(), null);
    //   }
    //   // vm.drawChart(vm.hourlyWithdrawal)
    // });
  },
  methods:{
    getGraphData(){
      let url = config.getGraphData();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.topWithdrawal = response.data.value.withrawal;
                // this.topWithdrawal = [
                //   {
                //       "member_id": "******6023",
                //       "withdrawal_amount": 850
                //   },
                //   {
                //       "member_id": "******4764",
                //       "withdrawal_amount": 600
                //   },
                //   {
                //       "member_id": "******3152",
                //       "withdrawal_amount": 518
                //   },
                //   {
                //       "member_id": "******9587",
                //       "withdrawal_amount": 500
                //   },
                //   {
                //       "member_id": "*******4355",
                //       "withdrawal_amount": 500
                //   },
                //   {
                //       "member_id": "******3428",
                //       "withdrawal_amount": 500
                //   },
                //   {
                //       "member_id": "******6535",
                //       "withdrawal_amount": 450
                //   },
                //   {
                //       "member_id": "******8622",
                //       "withdrawal_amount": 400
                //   },
                //   {
                //       "member_id": "******3428",
                //       "withdrawal_amount": 400
                //   },
                //   {
                //       "member_id": "******8622",
                //       "withdrawal_amount": 400
                //   }
                // ]
                this.hourlyWithdrawal = response.data.value.hour_withdrawal[0];
                // this.hourlyWithdrawal = 
                //   {
                //       "working_date": "2023-11-02T00:00:00",
                //       "action_type": "WITHDRAWAL",
                //       "amount00": 1389.89,
                //       "count00": 7,
                //       "amount01": 650,
                //       "count01": 2,
                //       "amount02": 396.03,
                //       "count02": 2,
                //       "amount03": 330,
                //       "count03": 2,
                //       "amount04": 455,
                //       "count04": 2,
                //       "amount05": 770,
                //       "count05": 4,
                //       "amount06": 495,
                //       "count06": 4,
                //       "amount07": 1233.9,
                //       "count07": 3,
                //       "amount08": 1010,
                //       "count08": 5,
                //       "amount09": 0,
                //       "count09": 0,
                //       "amount10": 1740.12,
                //       "count10": 5,
                //       "amount11": 882,
                //       "count11": 5,
                //       "amount12": 640,
                //       "count12": 5,
                //       "amount13": 0,
                //       "count13": 0,
                //       "amount14": 0,
                //       "count14": 0,
                //       "amount15": 0,
                //       "count15": 0,
                //       "amount16": 0,
                //       "count16": 0,
                //       "amount17": 0,
                //       "count17": 0,
                //       "amount18": 0,
                //       "count18": 0,
                //       "amount19": 0,
                //       "count19": 0,
                //       "amount20": 0,
                //       "count20": 0,
                //       "amount21": 0,
                //       "count21": 0,
                //       "amount22": 0,
                //       "count22": 0,
                //       "amount23": 0,
                //       "count23": 0
                // }
                this.registeredPlayer = response.data.value.registered_player[0].registered_player;
                this.activePlayer = response.data.value.active_player[0].active_player;
                // this.withdrawSpeed = response.data.value.deposited_player[0].deposited_player;
                if(response.data.value.deposited_player.length > 0){
                  this.withdrawSpeed = response.data.value.deposited_player[0].average_duration;
                }
                this.withdrawalCount = response.data.value.deposited_player[0].withdrawal_count;
                this.reviewCount = response.data.value.deposited_player[0].review_count;
                this.drawChart(this.hourlyWithdrawal);
                this.$nextTick(() => {
                  this.animateNum()
                });
                
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
          }
        }
      );
    },
    drawChart(data){
      var vm = this;
      //withdrawal count total
      var countTotal_1 = data.count00 + data.count01;
      var countTotal_2 = countTotal_1 + data.count02;
      var countTotal_3 = countTotal_2 + data.count03;
      var countTotal_4 = countTotal_3 + data.count04;
      var countTotal_5 = countTotal_4 + data.count05;
      var countTotal_6 = countTotal_5 + data.count06;
      var countTotal_7 = countTotal_6 + data.count07;
      var countTotal_8 = countTotal_7 + data.count08;
      var countTotal_9 = countTotal_8 + data.count09;
      var countTotal_10 = countTotal_9 + data.count10;
      var countTotal_11 = countTotal_10 + data.count11;
      var countTotal_12 = countTotal_11 + data.count12;
      var countTotal_13 = countTotal_12 + data.count13;
      var countTotal_14 = countTotal_13 + data.count14;
      var countTotal_15 = countTotal_14 + data.count15;
      var countTotal_16 = countTotal_15 + data.count16;
      var countTotal_17 = countTotal_16 + data.count17;
      var countTotal_18 = countTotal_17 + data.count18;
      var countTotal_19 = countTotal_18 + data.count19;
      var countTotal_20 = countTotal_19 + data.count20;
      var countTotal_21 = countTotal_20 + data.count21;
      var countTotal_22 = countTotal_21 + data.count22;
      var countTotal_23 = countTotal_22 + data.count23;

      //withdrawal amount total
      var amountTotal_00 = data.amount00;
      var amountTotal_01 = data.amount00 + data.amount01;
      var amountTotal_02 = amountTotal_01 + data.amount02;
      var amountTotal_03 = amountTotal_02 + data.amount03;
      var amountTotal_04 = amountTotal_03 + data.amount04;
      var amountTotal_05 = amountTotal_04 + data.amount05;
      var amountTotal_06 = amountTotal_05 + data.amount06;
      var amountTotal_07 = amountTotal_06 + data.amount07;
      var amountTotal_08 = amountTotal_07 + data.amount08;
      var amountTotal_09 = amountTotal_08 + data.amount09;
      var amountTotal_10 = amountTotal_09 + data.amount10;
      var amountTotal_11 = amountTotal_10 + data.amount11;
      var amountTotal_12 = amountTotal_11 + data.amount12;
      var amountTotal_13 = amountTotal_12 + data.amount13;
      var amountTotal_14 = amountTotal_13 + data.amount14;
      var amountTotal_15 = amountTotal_14 + data.amount15;
      var amountTotal_16 = amountTotal_15 + data.amount16;
      var amountTotal_17 = amountTotal_16 + data.amount17;
      var amountTotal_18 = amountTotal_17 + data.amount18;
      var amountTotal_19 = amountTotal_18 + data.amount19;
      var amountTotal_20 = amountTotal_19 + data.amount20;
      var amountTotal_21 = amountTotal_20 + data.amount21;
      var amountTotal_22 = amountTotal_21 + data.amount22;
      var amountTotal_23 = amountTotal_22 + data.amount23;
      
      window.chartColors = {
        green: '#348e40',
        greendark:'#314448',
        blue: '#01c7f8',
        bluedark:'#273d6e', 
      };
      this.displayChart = Highcharts.chart('chartsWd', {
        chart: {
          type: 'area',
          backgroundColor: "transparent",
          height: '500px'
        },
        title: {
          text: ""
        },
        legend:{
          align: "center",
          verticalAlign: "top",
          itemStyle: {
            color: '#ffffff'
          }
        },
        xAxis: {
          categories: ["12:00 am", "1:00 am","2:00 am", "3:00 am","4:00 am", "5:00 am", "6:00 am","7:00 am", "8:00 am", "9:00 am", "10:00 am", "11:00 am","12:00 pm","13:00 pm","14:00 pm","15:00 pm","16:00 pm","17:00 pm","18:00 pm","19:00 pm","20:00 pm","21:00 pm","22:00 pm","23:00 pm","23:59 pm"],
          tickmarkPlacement: 'on',
          title: {
            enabled: false
          },
          gridLineWidth: '1',
          gridLineDashStyle: 'ShortDash',
          gridLineColor: 'rgba(255,255,255,0.2)',
          lineWidth: 0,
          tickWidth: 0
        },
        yAxis: {
          title: {
            enabled: false
          },
          labels: {
            enabled: false
          },
          gridLineWidth: '0'
        },
        tooltip: {
          shared: true
          // split: true,
          // valueSuffix: ' millions'
        },
        plotOptions: {
          area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              // lineWidth: 1,
              // lineColor: '#666666'
              enabled: false
            },
            findNearestPointBy: 'x',
            label: {
              connectorAllowed: false
            },
            pointPlacement: 'on'
          }
        },
        series: [{
          name: vm.$tc('ui.amount'),
          // data: [106, 107, 111, 133, 221, 767, 1766, 106, 107, 111, 133, 221, 767, 1766, 106, 107, 111, 133, 221, 767, 1766, 1767, 1890, 1239, 1456],
          data:[
            0,
            data.amount00,
            Number(amountTotal_01.toFixed(2)),
            Number(amountTotal_02.toFixed(2)),
            Number(amountTotal_03.toFixed(2)),
            Number(amountTotal_04.toFixed(2)),
            Number(amountTotal_05.toFixed(2)),
            Number(amountTotal_06.toFixed(2)),
            Number(amountTotal_07.toFixed(2)),
            Number(amountTotal_08.toFixed(2)),
            Number(amountTotal_09.toFixed(2)),
            Number(amountTotal_10.toFixed(2)),
            Number(amountTotal_11.toFixed(2)),
            Number(amountTotal_12.toFixed(2)),
            Number(amountTotal_13.toFixed(2)),
            Number(amountTotal_14.toFixed(2)),
            Number(amountTotal_15.toFixed(2)),
            Number(amountTotal_16.toFixed(2)),
            Number(amountTotal_17.toFixed(2)),
            Number(amountTotal_18.toFixed(2)),
            Number(amountTotal_19.toFixed(2)),
            Number(amountTotal_20.toFixed(2)),
            Number(amountTotal_21.toFixed(2)),
            Number(amountTotal_22.toFixed(2)),
            Number(amountTotal_23.toFixed(2))
          ],
          borderColor: window.chartColors.greendark,
          color: window.chartColors.green
        }, {
          name: vm.$tc('ui.count'),
          // data: [502, 635, 809, 947, 1402, 3634, 5268, 635, 809, 947, 1402, 3634, 5268, 635, 809, 947, 1402, 3634, 5268, 1402, 3634, 5268, 5345, 3123, 1231],
          data:[
            0,
            data.count00*10,
            countTotal_1*10,
            countTotal_2*10,
            countTotal_3*10,
            countTotal_4*10,
            countTotal_5*10,
            countTotal_6*10,
            countTotal_7*10,
            countTotal_8*10,
            countTotal_9*10,
            countTotal_10*10,
            countTotal_11*10,
            countTotal_12*10,
            countTotal_13*10,
            countTotal_14*10,
            countTotal_15*10,
            countTotal_16*10,
            countTotal_17*10,
            countTotal_18*10,
            countTotal_19*10,
            countTotal_20*10,
            countTotal_21*10,
            countTotal_22*10,
            countTotal_23*10
          ],
          borderColor: window.chartColors.bluedark,
          color: window.chartColors.blue
        }],
        credits:{
          enabled: false
        }
      });
    },
    animateNum(){
      $('.counter-value').each(function () {
        $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {                      
              $(this).text(Math.ceil(this.Counter));
            }
        });
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.list-wrapper{
  background-color: rgba(30, 1, 60, 0.7);
}
</style>